import React, { useState } from "react";
import {
  Modal,
  Button,
  Row,
  Col,
  Divider,
  Input,
  Form,
  DatePicker,
  Select,
  Switch,
  Radio,
  RadioChangeEvent,
} from "antd";
import {
  CheckOutlined,
  CloseCircleOutlined,
  EditOutlined,
  PlusOutlined,
  SaveOutlined,
  UserAddOutlined,
} from "@ant-design/icons";
import "./SelectShipmentForm.css";
import moment from "moment";
import { useLocation } from "react-router-dom";

export interface SelectShipmentFormProps {
  showForm: boolean;
  postShipmentSelectedService: (
    selectedDate: string,
    lorryNumberPlate: string,
    lorryDriver: string,
    shipmentDirection: string
  ) => void;
}

const SelectShipmentForm = (props: SelectShipmentFormProps) => {
  const [lorryNumberPlate, setLorryNumberPlate] = useState("") as any;
  const [lorryDriver, setLorryDriver] = useState("");
  const [shipmentDirection, setShipmentDirection] = useState("") as any;

  const [lorryNumberPlateFormStatus, setLorryNumberPlateFormStatus] = useState("") as any;
  const [lorryNumberPlateFormMessage, setLorryNumberPlateFormMessage] = useState("");
  const [lorryDriverFormStatus, setLorryDriverFormStatus] = useState("") as any;
  const [lorryDriverFormMessage, setLorryDriverFormMessage] = useState("");
  const [shipmentDirectionFormStatus, setShipmentDirectionFormStatus] = useState("") as any;
  const [shipmentDirectionFormMessage, setShipmentDirectionFormMessage] = useState("");

  const [loadedShipment, setLoadedShipment] = useState({}) as any;
  const [selectedDate, setSelectedDate] = useState("");
  const [dateSelectedFormStatus, setDateSelectedFormStatus] = useState("") as any;
  const [dateSelectedFormMessage, setDateSelectedFormMessage] = useState("");
  const [selectedSupplier, setSelectedSupplier] = useState("");
  const [supplierSelectedFormStatus, setSupplierSelectedFormStatus] = useState("") as any;
  const [supplierSelectedFormMessage, setSupplierSelectedFormMessage] = useState("");
  const [isDateChanged, setIsDateChanged] = useState(false);
  const [supplierConfirmed, setSupplierConfirmed] = useState(false);
  const location = useLocation();

  const lorryNumberPlates = [
    {
      label: "PJP 6685 (Penang Lorry)",
      value: "PJP 6685",
    },
    {
      label: "PFF 6003 (Butterworth Lorry)",
      value: "PFF 6003",
    },
  ];

  const lorryDrivers = [
    {
      label: "Gopal",
      value: "Gopal",
    },
    {
      label: "Vijaykumar",
      value: "Vijaykumar",
    },
  ];

  const shipmentDirections = [
    {
      label: "PG -> BW",
      value: "pg",
    },
    {
      label: "BW -> PG",
      value: "bw",
    },
  ];

  const updateLorryNumberPlate = (value: any) => {
    setLorryNumberPlateFormStatus("");
    setLorryNumberPlateFormMessage("");
    setLorryNumberPlate(value);
  };

  const updateLorryDriver = (value: any) => {
    setLorryDriverFormStatus("");
    setLorryDriverFormMessage("");
    setLorryDriver(value);
  };

  const updateShipmentDirection = ({ target: { value } }: RadioChangeEvent) => {
    setShipmentDirectionFormStatus("");
    setShipmentDirectionFormMessage("");
    setShipmentDirection(value);
  };

  const validateForm = () => {
    let validationFormStatus = true;
    if (lorryNumberPlate === "") {
      validationFormStatus = false;
      setLorryNumberPlateFormStatus("error");
      setLorryNumberPlateFormMessage("Select a lorry");
    }
    if (lorryDriver === "") {
      validationFormStatus = false;
      setLorryDriverFormStatus("error");
      setLorryDriverFormMessage("Select a driver");
    }
    if (shipmentDirection === "") {
      validationFormStatus = false;
      setShipmentDirectionFormStatus("error");
      setShipmentDirectionFormMessage("Select a direction");
    }
    return validationFormStatus;
  };

  const resetShipmentInfo = () => {
    setLorryNumberPlate("");
    setLorryDriver("");
    setShipmentDirection("");
    setLorryNumberPlateFormStatus("");
    setLorryNumberPlateFormMessage("");
    setLorryDriverFormStatus("");
    setLorryDriverFormMessage("");
    setShipmentDirectionFormStatus("");
    setShipmentDirectionFormMessage("");
  };

  const isNewShipmentOrNotCompleted = () => {
    return location.pathname.split("/")[2] === undefined || !loadedShipment.completed;
  };

  const updateShipmentDate = (dateString: string) => {
    setDateSelectedFormStatus("");
    setDateSelectedFormMessage("");
    setSelectedDate(dateString);
  };

  const updateSetIsDateChanged = () => {
    setIsDateChanged(true);
  };

  const getUpdatedDate = () => {
    const dateProperties = selectedDate.split("/");
    return new Date(`${dateProperties[2]}-${dateProperties[1]}-${dateProperties[0]}`).toLocaleDateString("en-GB");
  };

  const startShipment = () => {
    props.postShipmentSelectedService(selectedDate, lorryNumberPlate, lorryDriver, shipmentDirection);
    setSupplierConfirmed(true);
    setIsDateChanged(false);
  };

  return props.showForm ? (
    <Row justify="center">
      <div className="select-supplier-form">
        <Row>
          <Col span={12}>
            <Row justify="start">
              <h2>Shipment Information</h2>
            </Row>
          </Col>
          <Col span={12}>
            <Row justify="end">
              {isNewShipmentOrNotCompleted() ? (
                isDateChanged ? (
                  <Form layout="vertical">
                    <Form.Item validateStatus={dateSelectedFormStatus} help={dateSelectedFormMessage}>
                      <DatePicker
                        allowClear={false}
                        onChange={(date, dateString) => updateShipmentDate(dateString)}
                        format={"DD/MM/YYYY"}
                        showToday
                        disabledDate={(current) => {
                          let customDate = moment().add(1, "day").format("YYYY-MM-DD");
                          return current && current > moment(customDate, "YYYY-MM-DD");
                        }}
                      />
                    </Form.Item>
                  </Form>
                ) : (
                  <>
                    {loadedShipment.createdTimestamp !== undefined ? (
                      <h2>{new Date(loadedShipment.createdTimestamp).toLocaleDateString("en-GB")}</h2>
                    ) : selectedDate !== "" ? (
                      <h2>{getUpdatedDate()}</h2>
                    ) : (
                      <h2>{new Date().toLocaleDateString("en-GB")}</h2>
                    )}
                    <Button
                      type="default"
                      onClick={() => updateSetIsDateChanged()}
                      icon={<EditOutlined />}
                      style={{ marginLeft: "10px" }}
                      disabled={supplierConfirmed}
                    ></Button>
                  </>
                )
              ) : (
                <h2>{new Date(loadedShipment.createdTimestamp).toLocaleDateString("en-GB")}</h2>
              )}
            </Row>
          </Col>
        </Row>
        <Row>
          <Divider style={{ margin: "12px 0" }} />
        </Row>
        <Form layout="vertical">
          <Form.Item
            label={<label className="material-form-label">Select a Lorry*</label>}
            validateStatus={lorryNumberPlateFormStatus}
            help={lorryNumberPlateFormMessage}
          >
            <Select
              showSearch
              placeholder="Select a Lorry"
              onChange={(value: any) => updateLorryNumberPlate(value)}
              optionFilterProp="label"
              onSearch={() => {}}
              options={lorryNumberPlates}
              style={{ width: "100%" }}
            />
          </Form.Item>
          <Form.Item
            label={<label className="material-form-label">Select a Driver*</label>}
            validateStatus={lorryDriverFormStatus}
            help={lorryDriverFormMessage}
          >
            <Select
              showSearch
              placeholder="Select a Driver"
              onChange={(value: any) => updateLorryDriver(value)}
              optionFilterProp="label"
              onSearch={() => {}}
              options={lorryDrivers}
              style={{ width: "100%" }}
            />
          </Form.Item>
          <Form.Item
            label={<label className="material-form-label">Select Shipment Direction*</label>}
            validateStatus={shipmentDirectionFormStatus}
            help={shipmentDirectionFormMessage}
          >
            <Radio.Group
              options={shipmentDirections}
              onChange={(value: any) => updateShipmentDirection(value)}
              // value={value4}
              optionType="button"
              buttonStyle="solid"
            />
          </Form.Item>
        </Form>
        <Row justify="center" style={{ marginTop: "20px" }}>
          <Button type="primary" icon={<CheckOutlined />} onClick={() => validateForm() && startShipment()}>
            Start Shipment
          </Button>
        </Row>
      </div>
      <div className="select-supplier-overlay"></div>
    </Row>
  ) : null;
};

export default SelectShipmentForm;
